import React from 'react';
import {Box, Typography} from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const COLOR_MAP = {
    success: '#2e7d32',
    warning: '#ed6c02',
    info: '#0288d1',
    default: '#757575',
};

/**
 * Displays a list of topics as clickable items.
 */
const TopicList = ({title, topics, color = 'default', onTopicClick}) => {
    if (!topics || topics.length === 0) return null;

    const indicatorColor = COLOR_MAP[color] || COLOR_MAP.default;

    return (
        <Box>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5}}>
                <FiberManualRecordIcon sx={{fontSize: 10, color: indicatorColor}}/>
                <Typography variant="caption" fontWeight={600} color="text.secondary">
                    {title}
                </Typography>
            </Box>
            <Box component="ul" sx={{m: 0, pl: 2.5, py: 0}}>
                {topics.map((topic, idx) => (
                    <Box
                        key={idx}
                        component="li"
                        sx={{color: 'text.primary', fontSize: '0.875rem', lineHeight: 1.6}}
                    >
                        <Box
                            component="span"
                            onClick={() => onTopicClick?.(topic.tag)}
                            sx={{
                                cursor: 'pointer',
                                textDecoration: 'underline dotted',
                                '&:hover': {color: indicatorColor},
                            }}
                        >
                            {topic.tag}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default TopicList;
